module.exports = "/assets/data/5e205f31e002e2c1a91a193beba5adbc-TF2.data.json";